var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _path9, _path10, _path11, _path12, _path13, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPhthalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 209,
    viewBox: "0 0 283 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_1437)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_1437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 171,
    width: 27,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7817 176.544H29.1536C33.3126 176.544 36.4437 180.423 36.4437 184.354C36.4437 188.556 33.096 192.218 29.0997 192.218H22.7817V176.544ZM16.6255 171.159V210.638H22.7817V197.604H29.1536C32.6694 197.604 36.0412 196.211 38.5272 193.731C41.0133 191.252 42.4099 187.889 42.4099 184.382C42.4099 180.876 41.0133 177.513 38.5272 175.033C36.0412 172.553 32.6694 171.16 29.1536 171.16L16.6255 171.159Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3843 171.159H16.6255V210.638H42.3843V171.159Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_131_1437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 171,
    width: 28,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8933 171.159V191.948H58.7992V171.159H52.6429V210.638H58.7992V197.604H72.8933V210.638H79.0495V171.159H72.8933Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_131_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.0495 171.159H52.6429V210.638H79.0495V171.159Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_131_1437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 171,
    width: 28,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.309 171.159L88.769 176.271H98.8677V210.638H105.023V176.275H115.122L114.582 171.162L89.309 171.159Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_131_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.122 171.159H88.769V210.638H115.122V171.159Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_131_1437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 171,
    width: 28,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.087 171.159V191.948H130.997V171.159H124.84V210.638H130.997V197.604H145.087V210.638H151.244V171.159H145.087Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_131_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.247 171.159H124.84V210.638H151.247V171.159Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_131_1437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 170,
    width: 34,
    height: 41
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.762 186.186L181.053 199.435H170.47L175.762 186.186ZM159.886 210.638H165.984L168.359 204.875H183.156L185.531 210.638H192.174L176.081 170.566L159.886 210.638Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_131_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.179 170.566H159.887V210.638H192.179V170.566Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_131_1437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 171,
    width: 23,
    height: 40
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.819 171.159V210.638H222.365L222.905 204.982H207.085V171.159H200.819Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_131_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.905 171.159H200.819V210.638H222.905V171.159Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_131_1437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 170,
    width: 42,
    height: 42
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M231.76 190.979C231.76 183.439 238.078 175.898 246.017 175.898C253.522 175.898 260.218 183.061 260.218 190.979C260.218 198.25 254.121 206.06 246.017 206.06C238.51 206.06 231.76 198.95 231.76 190.979ZM225.604 190.979C225.693 196.346 227.874 201.468 231.685 205.258C235.496 209.049 240.637 211.21 246.018 211.284C256.712 211.284 266.376 202.293 266.376 190.979C266.309 185.615 264.142 180.489 260.339 176.696C256.536 172.902 251.397 170.741 246.018 170.674C235.273 170.674 225.604 179.615 225.604 190.979Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_131_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.374 170.674H225.604V211.284H266.374V170.674Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.929 0.321632C141.469 3.94227 138.205 9.43664 135.431 15.2127C135.063 15.9798 133.835 17.6397 132.98 16.3393C132.782 16.0209 132.682 15.6512 132.694 15.2766C132.716 12.7716 132.805 10.2766 132.703 7.77265C132.654 6.59307 132.162 5.31461 130.674 5.79803C130.281 5.93271 129.921 6.15041 129.62 6.43626C126.491 9.33156 124.257 13.0592 123.182 17.1793C123.069 17.6148 122.629 19.2668 122.315 20.9607C118.546 21.7754 114.834 22.8354 111.204 24.1339L103.069 12.3312C103.069 12.3312 86.304 -9.54847 74.9639 14.3028C63.6239 38.154 74.9639 60.7757 74.9639 60.7757C74.9639 60.7757 63.3766 79.9526 59.9247 93.2366H65.102L59.9247 99.8756L64.8556 100.859L59.9247 106.023C59.9247 106.023 69.5202 136.257 131.119 141.898C151.984 143.809 174.594 140.437 193.791 131.923C203.985 127.401 213.985 120.798 220.228 111.359C220.486 110.97 223.496 106.502 223.032 106.023L218.101 100.859L223.032 99.8756L217.847 93.2336H223.023C219.572 79.9556 207.985 60.7727 207.985 60.7727C207.985 60.7727 219.326 38.151 207.985 14.2998C196.644 -9.55146 179.879 12.3331 179.879 12.3331L171.744 24.1359C167.903 22.7628 163.971 21.6571 159.976 20.8269C159.384 19.2238 159.13 17.5164 159.228 15.811C159.258 14.6098 159.439 13.4172 159.768 12.2612C159.829 12.0495 160.356 10.2636 160.616 9.40268C160.663 9.25328 160.652 9.09176 160.586 8.94996C160.519 8.80816 160.402 8.69637 160.256 8.63661C158.354 7.88252 155.988 11.3573 154.819 12.7007C153.546 14.1619 152.508 15.807 151.332 17.3461C150.962 17.8843 150.497 18.3507 149.96 18.7224C149.689 18.9057 149.378 19.0213 149.053 19.0594C148.728 19.0975 148.398 19.0569 148.092 18.9412C147.091 18.4917 146.883 17.1933 146.841 16.1026C146.654 11.2063 147.15 6.30792 148.317 1.54815C148.45 1.00481 148.502 0.267697 147.986 0.0499595C147.907 0.0163355 147.821 -0.000661753 147.735 1.97088e-05C147.441 0.0295762 147.162 0.141036 146.929 0.321632Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.186 30.1597C182.929 25.4282 185.708 21.1441 189.322 17.6198C195.485 11.4722 201.155 16.636 202.14 25.4883C203.124 34.3407 200.907 41.7168 199.428 44.1768L198.441 36.3083L195.73 40.7339C195.73 40.7339 192.031 35.3245 194.251 32.6197C196.47 29.915 189.566 33.1121 189.566 36.0626C189.566 36.0626 191.785 28.6765 187.1 27.9484C187.1 27.9484 188.087 32.6197 185.375 33.1121L181.186 30.1597Z",
    fill: "#312767"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.257 32.0904C100.514 27.3588 97.7344 23.0748 94.1211 19.5505C87.9573 13.4029 82.2873 18.5667 81.3029 27.419C80.3185 36.2713 82.5357 43.6474 84.0148 46.1075L85.0012 38.2389L87.713 42.6646C87.713 42.6646 91.4102 37.2551 89.1921 34.5504C86.974 31.8457 93.8767 35.0428 93.8767 37.9932C93.8767 37.9932 91.6576 30.6072 96.3422 29.879C96.3422 29.879 95.3558 34.5504 98.0676 35.0428L102.257 32.0904Z",
    fill: "#312767"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M205.475 53.0771C200.989 51.0436 196.139 49.9302 191.212 49.803C180.224 49.3475 169.218 49.563 158.257 50.4483C153.55 50.8478 148.28 51.1474 144.946 51.3182H138.056C134.721 51.1474 129.455 50.8468 124.745 50.4483C113.783 49.563 102.777 49.3475 91.7887 49.803C86.8627 49.9303 82.0127 51.0437 77.5265 53.0771C67.7547 57.9322 66.1535 70.3662 67.5324 80.0446C69.0746 90.8695 74.7426 100.184 86.0135 102.841C86.6424 102.989 87.2767 103.116 87.9162 103.222C105.502 106.169 126.965 103.609 132.504 85.1574C132.504 85.1574 136.144 71.367 141.506 71.4799C146.868 71.367 150.508 85.1574 150.508 85.1574C156.038 103.611 177.504 106.171 195.093 103.225C195.729 103.118 196.363 102.991 196.995 102.844C208.266 100.187 213.935 90.8715 215.478 80.0476C216.856 70.3672 215.256 57.9342 205.483 53.0801M81.6794 56.3811H129.729C131.204 57.1929 132.317 58.5287 132.849 60.1226H77.0809C78.2239 58.4632 79.8202 57.1649 81.6794 56.3811ZM89.9902 99.2204C89.3397 99.0873 88.698 98.9148 88.0685 98.7041H112.042C101.035 102.816 89.9902 99.2204 89.9902 99.2204ZM118.002 95.6068H81.8146C80.193 94.4855 78.7391 93.1404 77.4965 91.6116H122.619C121.232 93.1093 119.682 94.4492 117.999 95.6068M125.132 88.5104H75.4466C74.7697 87.2367 74.228 85.8961 73.8303 84.5102H127.583C126.856 85.8965 126.037 87.2328 125.131 88.5104M129.121 81.4139H73.1624C72.9695 80.0892 72.8731 78.7523 72.874 77.4137H130.856C130.357 78.6735 129.777 80.0069 129.116 81.4139M131.981 74.3175H73.0202C73.0442 74.0608 73.0673 73.8041 73.0963 73.5434C73.1374 72.4631 73.2397 71.386 73.4027 70.3173H133.087C132.79 71.6688 132.422 73.004 131.986 74.3175M133.588 67.22H74.0036C74.3359 65.8533 74.7827 64.5169 75.3395 63.2248H133.596C133.734 64.5532 133.73 65.8925 133.584 67.22M153.272 56.3811H201.322C203.181 57.1651 204.776 58.4634 205.919 60.1226H150.152C150.684 58.5287 151.797 57.1929 153.272 56.3811ZM149.404 63.2198H207.659C208.217 64.5118 208.664 65.8482 208.996 67.215H149.412C149.266 65.8875 149.262 64.5482 149.4 63.2198M149.914 70.3163H209.598C209.761 71.3851 209.863 72.4622 209.905 73.5424C209.934 73.8041 209.958 74.0598 209.981 74.3165H151.014C150.578 73.0029 150.212 71.6677 149.914 70.3163ZM193.008 99.2204C193.008 99.2204 181.963 102.816 170.957 98.7041H194.93C194.301 98.9149 193.658 99.0873 193.008 99.2204ZM201.182 95.6068H165.001C163.318 94.449 161.769 93.1091 160.382 91.6116H205.507C204.265 93.1404 202.811 94.4855 201.189 95.6068M207.557 88.5104H157.869C156.963 87.2328 156.144 85.8965 155.417 84.5102H209.17C208.772 85.8961 208.23 87.2367 207.553 88.5104M209.838 81.4139H153.878C153.216 80.0056 152.636 78.6722 152.139 77.4137H210.121C210.122 78.7523 210.025 80.0892 209.833 81.4139",
    fill: "#312767"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 77.1022C136.45 76.9963 133.022 89.9867 133.022 89.9867C132.378 92.1702 131.419 94.2485 130.174 96.1562C128.682 98.3714 127.541 100.802 126.79 103.364C126.59 104.063 126.448 104.638 126.363 105.061C125.486 109.428 123.11 116.789 132.242 120.783C138.251 122.779 144.748 122.779 150.757 120.783C159.889 116.787 157.513 109.428 156.636 105.061C156.552 104.639 156.405 104.063 156.209 103.364C155.458 100.802 154.317 98.3714 152.825 96.1562C151.58 94.2485 150.621 92.1702 149.977 89.9867C149.977 89.9867 146.549 77.0023 141.499 77.1022",
    fill: "#312767"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_131_1437",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 97,
    width: 23,
    height: 22
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.534 97.7162C132.134 97.7162 131.601 97.7162 131.376 97.9529C130.977 98.3365 130.726 98.8477 130.667 99.3972C130.737 99.9304 131.004 100.419 131.414 100.768C134.001 103.111 136.647 105.391 139.233 107.737C139.678 108.111 139.976 108.629 140.075 109.2C140.175 111.361 140.08 113.53 140.169 115.693C140.217 116.85 139.729 117.091 138.718 116.959C136.931 116.718 135.134 116.543 133.346 116.3C132.639 116.2 131.862 116.06 131.769 116.978C131.741 117.255 132.478 117.817 132.932 117.906C138.54 118.964 144.3 118.93 149.895 117.806C150.388 117.711 151.181 117.148 151.167 116.833C151.121 115.843 150.276 116.101 149.608 116.189C147.473 116.471 145.337 116.742 142.959 117.05C142.959 114.053 142.935 111.274 142.995 108.498C143.001 108.222 143.481 107.916 143.789 107.689C146.687 105.558 149.659 103.494 151.772 100.517C151.99 100.224 152.146 99.8901 152.231 99.5352C152.316 99.1802 152.327 98.8118 152.264 98.4523C152.121 98.0418 151.077 97.7442 150.432 97.7382C147.307 97.7102 144.183 97.6979 141.058 97.7012C138.216 97.7012 135.374 97.7059 132.532 97.7152",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_131_1437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.468 97.7021H130.664V119.002H152.468V97.7021Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_1437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283,
    height: 209,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPhthalo);
export default __webpack_public_path__ + "static/media/Logo-Phthalo.567a1f8173bdee3982065df0ff63fbaa.svg";
export { ForwardRef as ReactComponent };